<template>
  <component :is="stepComponent" v-if="stepComponent && isStepVisible" :step="currentStep" />
</template>

<script setup lang="ts">
import { computed, type Component } from 'vue'
import { useGiftModal } from '@/features/gift/store'
import type { GiftStep } from '@/features/gift/types/gift-config'

import WelcomeStep from './WelcomeStep.vue'
import RecipientInfoStep from './RecipientInfoStep.vue'
import PriceRangeStep from './PriceRangeStep.vue'
import InterestsStep from './InterestsStep.vue'
import OccasionStep from './OccasionStep.vue'
import BrandSelectionStep from './BrandSelectionStep.vue'
import StyleLikesStep from './StyleLikesStep.vue'
import CompletionStep from './CompletionStep.vue'

const giftStore = useGiftModal()
const currentStep = computed(() => giftStore.currentStep)

const isStepVisible = computed(() => {
  const step = currentStep.value
  if (!step) return false
  
  return giftStore.shouldStepBeVisible(step)
})

/**
 * Тип намеренно `Component`: каждый шаг объявляет свой проп узко, а
 * `<component :is>` проверяет `:step` против всех вариантов сразу — для union'а
 * это недоказуемо. Соответствие типа шага компоненту держит switch ниже.
 */
const stepComponent = computed<Component | null>(() => {
  const step = currentStep.value
  if (!step) return null

  switch (step.type) {
    case 'welcome':
      return WelcomeStep
    case 'recipient_info':
      return RecipientInfoStep
    case 'price_range':
      return PriceRangeStep
    case 'interests':
      return InterestsStep
    case 'occasion':
      return OccasionStep
    case 'brand_selection':
      return BrandSelectionStep
    case 'style_likes':
      return StyleLikesStep
    case 'completion':
      return CompletionStep
    default:
      console.warn(`Unknown step type: ${(step as any).type}`)
      return null
  }
})
</script>

